module.exports = __webpack_public_path__ + "static/img/13.bc768887.jpg";